/* eslint-disable @typescript-eslint/no-inferrable-types */
/**
 * Specifies smithchart animationComplete event name.
 *
 * @private
 */
export var animationComplete = 'animationComplete';
/**
 * Specifies smithchart legendRender event name.
 *
 * @private
 */
export var legendRender = 'legendRender';
/**
 * Specifies smithchart titleRender event name.
 *
 * @private
 */
export var titleRender = 'titleRender';
/**
 * Specifies smithchart subtitleRender event name.
 *
 * @private
 */
export var subtitleRender = 'subtitleRender';
/**
 * Specifies smithchart textRender event name.
 *
 * @private
 */
export var textRender = 'textRender';
/**
 * Specifies smithchart seriesRender event name.
 *
 * @private
 */
export var seriesRender = 'seriesRender';
/**
 * Specifies smithchart load event name.
 *
 * @private
 */
export var load = 'load';
/**
 * Specifies smithchart loaded event name.
 *
 * @private
 */
export var loaded = 'loaded';
/**
 * Specifies smithchart axisLabelRender event name.
 *
 * @private
 */
export var axisLabelRender = 'axisLabelRender';
